/**
 * useCreatorEarnings Hook (Web)
 * Web-specific wrapper around shared useCreatorEarnings
 */

import { useAuth } from '@contexts/AuthContext';
import { createHttpClient } from '@parlay-picker/shared/api/httpClient';
import {
  type UseCreatorEarningsResult,
  useCreatorEarnings as useCreatorEarningsShared,
} from '@parlay-picker/shared/hooks';
import { useMemo } from 'react';
import { API_BASE_URL } from '../config/api';

export type { UseCreatorEarningsResult };
export type {
  EarningsData,
  FollowerPreview,
  PeriodDetail,
} from '@parlay-picker/shared/hooks';

export function useCreatorEarnings(): UseCreatorEarningsResult {
  const { authFetch, isAuthenticated } = useAuth();

  const httpClient = useMemo(
    () => createHttpClient({ authFetch, baseUrl: API_BASE_URL }),
    [authFetch],
  );

  return useCreatorEarningsShared({ httpClient, isAuthenticated });
}
